import React from 'react';
import Login from '../../screens/Login/Login';
import { PageFooter } from '../../shared/components/PageFooter/PageFooter';
import './App.scss';

export class App extends React.Component {
    render() {
        return (
            <div className="App">
                <div className="react-container">
                    <Login />
                    <PageFooter />
                </div>
            </div>
        );
    }
}

export default App;
